import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { HelmetProvider } from "react-helmet-async"

import "./index.css"
import App from "./App.tsx"
import { ThemeProvider } from "@/components/theme-provider.tsx"
import { getEventSlugFromUrl } from "@/lib/utils"
import { injectFonts } from "@/lib/fonts"
import { initPostHog } from "@/lib/posthog"

// Load the Google Fonts into the document <head> (see src/lib/fonts.ts).
injectFonts()

const root = createRoot(document.getElementById("root")!)

async function render() {
  if (import.meta.env.DEV) {
    const { DevRoot } = await import("./dev/DevRoot.tsx")

    root.render(
      <StrictMode>
        <HelmetProvider>
          <ThemeProvider defaultTheme="dark">
            <DevRoot />
          </ThemeProvider>
        </HelmetProvider>
      </StrictMode>
    )

    return
  }

  // The production SPA has no theme toggle — it locks to the event's theme,
  // applied to <html> by useBrandingSync once the event loads. Default to dark
  // for the pre-load loading screen. (No ThemeProvider here: that's only for the
  // dev showcase chrome's manual toggle.)
  initPostHog()
  document.documentElement.classList.add("dark")
  root.render(
    <StrictMode>
      <HelmetProvider>
        <App
          slug={getEventSlugFromUrl()}
          mode="website"
          placement="full-app"
        />
      </HelmetProvider>
    </StrictMode>
  )
}

render()
